import { MenuItem, Select } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";

import { additionalColors } from "constants/colors";

export const FormDropdownObjectsField = ({
    selectedOption = {} as any,
    allOptions,
    placeholder = "",
    setSelectedOption,
    disabled = false,
    optionStyling = {},
    defaultOptionStyling = {},
}) => {
    return (
        <FormControl fullWidth>
            <Select
                style={
                    !selectedOption?.value
                        ? { color: additionalColors.grey500, backgroundColor: "#FFF" }
                        : optionStyling[selectedOption.key] || defaultOptionStyling
                }
                disabled={disabled}
                variant="outlined"
                name="selectedAction"
                value={selectedOption.value || ""}
                data-testid="dropdown-test-id"
                onChange={(e) => {
                    setSelectedOption(e.target.value as string);
                }}
                displayEmpty
                renderValue={!selectedOption?.value ? () => placeholder : undefined}
            >
                {allOptions.map((option) => (
                    <MenuItem
                        style={optionStyling[option.key] || defaultOptionStyling}
                        key={option.key}
                        value={option.key}
                    >
                        {option.value}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
export default FormDropdownObjectsField;
